/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : settings.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";
const settingsApis = {
  get_app_meta_data: {
    api_name: "/SCM/settings/app_meta",
    https_method: "GET",
    action_type: actionType.GET_APP_META_DATA,
    description: "",
  },
  add_git_webhook: {
    api_name: "/VLC/swm/add_meta_data",
    https_method: "POST",
    action_type: actionType.ADD_GIT_WEBHOOK,
    description: "Add Git webhook comgig",
  },
};

export default settingsApis;
